import DOMPurify from "dompurify";
import {Button} from "../../ui/button";
import {viewStates} from "./view-states";
import React from "react";
import {useLazyCommand} from "@soap/modules";
import {useParams} from "react-router";

export function Instruction({html, setViewState, e170}) {
    const {sharedAssessmentLinkId} = useParams();
    const [sendStartAssessmentCommand] = useLazyCommand("C276v1_StartAssessment");
    const purifiedContent = DOMPurify.sanitize(html, {USE_PROFILES: {html: true}});
    
    const hasStudentId = e170?.e170_Student?.e170_StudentId != null;
    
    const handleStartAssessment = async () => {
        if (hasStudentId) {
            // Start directly when StudentId is available
            await sendStartAssessmentCommand({
                C276_SharedAssessmentId: sharedAssessmentLinkId
            });
        } else {
            // For anonymous shares without StudentId, go to question view
            // TODO: Handle anonymous shares properly
            setViewState(viewStates.showQuestion);
        }
    };
    
    return (
        <div className="space-y-6">
            <div className="flex justify-start">
                <Button 
                    variant="outline" 
                    onClick={() => {
                        setViewState(viewStates.welcome);
                    }}
                    className="px-4 py-2"
                >
                    Back
                </Button>
            </div>
            
            <div className="prose max-w-none">
                <div dangerouslySetInnerHTML={{__html: purifiedContent}}/>
            </div>
            
            <div className="flex justify-end pt-4">
                <Button 
                    onClick={handleStartAssessment}
                    className="px-6 py-2"
                >
                    Begin Assessment
                </Button>
            </div>
        </div>
    )
}




